import { useEffect, useState } from "react";
import { GetAxios } from "../helpers/axiosHelpers";

export const useSections = (page) => {
  const [sections, setSections] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    GetAxios(`/page-sections/public?page=${page}`)
      .then((res) => {
        if (res?.success && Array.isArray(res.data) && res.data.length > 0) {
          setSections(res.data);
        }
      })
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, [page]);

  return { sections, loaded };
};
